import React from 'react';

import { SignatureFrame } from '../../../common/pokCore/validation/signatureFrame';

import { fitImageInBoxPercent } from './signatureFrameGeometry';
import { PreviewImage } from './useSignaturePreviewImages';

interface SignaturePreviewBoxProps {
  image?: PreviewImage;
  leftPt: number;
  widthPt: number;
}

export const SignaturePreviewBox: React.FC<SignaturePreviewBoxProps> = ({
  image,
  leftPt,
  widthPt,
}) => {
  const size = image && fitImageInBoxPercent(image, widthPt);
  return (
    <div
      className="signature-frame__box"
      style={{
        left: `${(leftPt / SignatureFrame.widthPt) * 100}%`,
        width: `${(widthPt / SignatureFrame.widthPt) * 100}%`,
      }}
    >
      {image && size && (
        <img
          src={image.src}
          alt=""
          draggable={false}
          style={{ width: `${size.width}%`, height: `${size.height}%` }}
        />
      )}
    </div>
  );
};
